// Componente de skeleton para el programa de afiliados - Skeleton component for affiliates program
// Muestra placeholders que respetan la estructura de los bloques de la página
import { configurationPageClass } from '@modules/configuration/components/configurationLayout';
import { SectionBox } from '@shared/components/ui/SectionBox';
import { Skeleton } from '@shared/components/ui/shadcn/skeleton';

export const AffiliatesSkeleton = () => {
  return (
    <div className={configurationPageClass}>
      {/* Program Section Skeleton - Skeleton de la sección del programa */}
      <div className="flex flex-col items-center w-full border-b border-card-border pb-8 pt-4 mb-8">
        <Skeleton className="h-8 w-64 rounded-full mb-2 bg-hover-press" />
        <Skeleton className="h-5 w-96 rounded-full mb-10 bg-hover-press" />
        <div className="flex flex-col md:flex-row justify-center items-center gap-4 w-full">
          {/* Step 1 - Paso 1 */}
          <div className="flex flex-col items-center text-center">
            <Skeleton className="h-6 w-6 rounded-full mb-3 bg-hover-press" />
            <Skeleton className="h-4 w-40 rounded-full bg-hover-press" />
          </div>
          <div className="w-20 h-px bg-card-border my-4 mx-0 hidden md:block" />
          {/* Step 2 - Paso 2 */}
          <div className="flex flex-col items-center text-center">
            <Skeleton className="h-6 w-6 rounded-full mb-3 bg-hover-press" />
            <Skeleton className="h-4 w-40 rounded-full bg-hover-press" />
          </div>
          <div className="w-20 h-px bg-card-border my-4 mx-0 hidden md:block" />
          {/* Step 3 - Paso 3 */}
          <div className="flex flex-col items-center text-center">
            <Skeleton className="h-6 w-6 rounded-full mb-3 bg-hover-press" />
            <Skeleton className="h-4 w-40 rounded-full bg-hover-press" />
          </div>
        </div>
      </div>

      {/* Benefits Section Skeleton - Skeleton de la sección de beneficios */}
      <div className="w-full mt-8 border-b border-card-border pb-6 mb-8">
        <Skeleton className="h-6 w-48 rounded-full mx-auto mb-8 bg-hover-press" />
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          {[1, 2, 3, 4].map((index) => (
            <SectionBox key={index}>
              <Skeleton className="h-10 w-10 rounded-lg mb-4 bg-hover-press" />
              <div>
                <Skeleton className="h-5 w-32 rounded-full mb-1 bg-hover-press" />
                <Skeleton className="h-4 w-full rounded-full bg-hover-press" />
                <Skeleton className="h-4 w-3/4 rounded-full mt-1 bg-hover-press" />
              </div>
            </SectionBox>
          ))}
        </div>

        {/* Affiliate Code and Earnings Summary Skeleton - Skeleton del código de afiliado y resumen de ganancias */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-8">
          {/* Affiliate Code Section - Sección de código de afiliado */}
          <SectionBox>
            <Skeleton className="h-5 w-40 rounded-full mb-2 bg-hover-press" />
            <div className="relative mb-2">
              <Skeleton className="h-10 w-full bg-hover-press" />
            </div>
            <Skeleton className="h-4 w-64 rounded-full bg-hover-press" />
          </SectionBox>
          {/* Earnings Summary Section - Sección de resumen de ganancias */}
          <SectionBox className="flex flex-col">
            <Skeleton className="h-5 w-40 rounded-full mb-2 bg-hover-press" />
            <div className="flex flex-col gap-2">
              <div className="flex items-center justify-between">
                <Skeleton className="h-4 w-32 rounded-full bg-hover-press" />
                <Skeleton className="h-6 w-24 rounded-full bg-hover-press" />
              </div>
              <div className="flex items-center justify-between">
                <Skeleton className="h-4 w-28 rounded-full bg-hover-press" />
                <Skeleton className="h-6 w-28 rounded-full bg-hover-press" />
              </div>
            </div>
          </SectionBox>
        </div>
      </div>

      {/* Commissions History Section Skeleton - Skeleton de la sección de historial de comisiones */}
      <div>
        <Skeleton className="h-6 w-56 rounded-full mb-4 bg-hover-press" />

        {/* Table Skeleton - Skeleton de la tabla (desktop) */}
        <div className="hidden md:block">
          <div className="border border-card-border rounded-lg overflow-hidden">
            {/* Table Header - Encabezado de tabla */}
            <div className="grid grid-cols-5 gap-4 p-4 border-b border-card-border bg-card-bg">
              <Skeleton className="h-4 w-24 rounded-full bg-hover-press" />
              <Skeleton className="h-4 w-20 rounded-full bg-hover-press" />
              <Skeleton className="h-4 w-16 bg-hover-press" />
              <Skeleton className="h-4 w-24 rounded-full bg-hover-press" />
              <Skeleton className="h-4 w-20 rounded-full bg-hover-press" />
            </div>
            {/* Table Rows - Filas de tabla */}
            {[1, 2, 3].map((index) => (
              <div key={index} className="grid grid-cols-5 gap-4 p-4 border-b border-card-border last:border-b-0">
                <Skeleton className="h-4 w-32 rounded-full bg-hover-press" />
                <Skeleton className="h-4 w-24 rounded-full bg-hover-press" />
                <Skeleton className="h-4 w-20 rounded-full bg-hover-press" />
                <Skeleton className="h-4 w-16 bg-hover-press" />
                <Skeleton className="h-4 w-24 rounded-full bg-hover-press" />
              </div>
            ))}
          </div>
        </div>

        {/* Card List Skeleton - Skeleton de la lista de tarjetas (mobile) */}
        <div className="md:hidden space-y-4">
          {[1, 2, 3].map((index) => (
            <SectionBox key={index} className="p-4">
              <div className="flex items-center justify-between mb-3">
                <Skeleton className="h-5 w-32 rounded-full bg-hover-press" />
                <Skeleton className="h-6 w-16 rounded-full bg-hover-press" />
              </div>
              <div className="space-y-2">
                <Skeleton className="h-4 w-24 rounded-full bg-hover-press" />
                <Skeleton className="h-4 w-20 rounded-full bg-hover-press" />
                <Skeleton className="h-4 w-28 rounded-full bg-hover-press" />
              </div>
            </SectionBox>
          ))}
        </div>
      </div>
    </div>
  );
};
